import { COLORS } from '@/constants/calculator';

const PURPLE_BG = { backgroundColor: COLORS.PURPLE };
const ROW_BORDER = { borderColor: COLORS.WHITE_BORDER_TRANSPARENT };
const ORANGE_TEXT = { color: COLORS.ORANGE };

const BreakdownRow = ({ label, amount, testId }) => (
  <div className="flex justify-between items-center pb-3 border-b" style={ROW_BORDER}>
    <span className="text-purple-100">{label}</span>
    <span className="font-bold" data-testid={testId}>
      ${amount.toFixed(2)}
    </span>
  </div>
);

export const CostBreakdown = ({
  holidayPay,
  holidayAmount,
  supervisorCost,
  nonProductiveTime,
  nonProductiveAmount,
  nonEssentialDowntime,
  nonEssentialAmount,
  totalCosts,
}) => (
  <div className="text-white p-8 mt-8" style={PURPLE_BG}>
    <label className="text-xs tracking-[0.2em] uppercase font-bold text-purple-200 block mb-6">
      COST BREAKDOWN
    </label>

    <div className="space-y-4">
      <BreakdownRow
        label={`Holiday/Sick/ACC/KS (${holidayPay}%)`}
        amount={holidayAmount}
        testId="breakdown-holiday"
      />
      <BreakdownRow
        label="Supervisor Cost"
        amount={supervisorCost}
        testId="breakdown-supervisor"
      />
      <BreakdownRow
        label={`Non-Productive Time (${nonProductiveTime}%)`}
        amount={nonProductiveAmount}
        testId="breakdown-non-productive"
      />
      <BreakdownRow
        label={`Non-Essential Downtime (${nonEssentialDowntime}%)`}
        amount={nonEssentialAmount}
        testId="breakdown-non-essential"
      />

      <div className="flex justify-between items-center pt-3">
        <span className="text-lg font-bold text-white">Total Management Cost</span>
        <span className="text-2xl font-black" style={ORANGE_TEXT} data-testid="breakdown-total">
          ${totalCosts.toFixed(2)}
        </span>
      </div>
    </div>
  </div>
);
